import React from 'react';

const FastForwardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 2.5L5.5 6L1 9.5V2.5Z" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 2.5L10.5 6L6 9.5V2.5Z" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default FastForwardIcon;
